import DereferenceError from "./DereferenceError.mjs";
class UnmatchedDereferenceStrategyError extends DereferenceError {}
export default UnmatchedDereferenceStrategyError;